"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorTierDeclinePanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var React = require("react");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_model_1 = require("@athena-portal/journey-model");
var AnnualMotorTierDeclinePanelWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorTierDeclinePanelWidget, _super);
    function AnnualMotorTierDeclinePanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.manuallyPassedProcess = _this.getSetting(_this.process, "");
        return _this;
    }
    AnnualMotorTierDeclinePanelWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        var process = this.manuallyPassedProcess || interaction.process;
        var isAddDriverMta = process === services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_ADD_ADDITIONAL_DRIVER ||
            process === services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER;
        var tier = (0, commonFunctions_1.getCoverTierWording)(interaction.coverTier);
        var eligibleTiers = this.getEligibleTierWording(interaction);
        var isSilver = services_1.resourcesHelper.THEME === "Allianz" && interaction.coverTier === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2;
        var canChangeToBronze = isSilver && interaction.tierEligibility.essentials;
        var coverChangeAction = canChangeToBronze ? "change" : "upgrade";
        var action = isSilver ? "".concat(coverChangeAction, " your cover level to") : "upgrade to";
        var showCoverLevelSuffix = !isSilver || (interaction.tierEligibility.essentials && interaction.tierEligibility.allianz);
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isAddDriverMta && !isSilver ?
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { className: "", children: "Change your cover to add this driver..." }), (0, jsx_runtime_1.jsxs)("div", { className: "panel", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we can't add ", interaction.uistate.addedDriverFullName, " on your ", tier, " policy due to some of our underwriting rules."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["If you cancel your changes, you\u2019ll stay on our ", tier, " cover level."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["If you\u2019d like to continue with your changes, we\u2019ll give you a quote to add this driver and upgrade to ", eligibleTiers, " cover level."] })] })] })
                :
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h1", { className: "", children: [canChangeToBronze ? "Change your cover level" : "Upgrade your cover", " to continue with your change\u2026"] }), (0, jsx_runtime_1.jsxs)("div", { className: "panel", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we can\u2019t make this change on your ", tier, " policy due to some of our underwriting rules."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["If you cancel your changes, you\u2019ll stay on ", tier, " cover level."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["if you\u2019d like to continue with your changes, we\u2019ll give you a quote to ", action, " ", eligibleTiers, showCoverLevelSuffix ? " cover level." : "."] })] })] }) }));
    };
    AnnualMotorTierDeclinePanelWidget.prototype.getEligibleTierWording = function (interaction) {
        var _this = this;
        var tierEligibility = interaction.tierEligibility;
        var eligibleTiers = Object.entries(tierEligibility)
            .filter(function (_a) {
            var tier = _a[0], eligible = _a[1];
            return eligible && tier !== "coverTier";
        })
            .map(function (_a, i, arr) {
            var tier = _a[0];
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("strong", { children: _this.getTierWordingFromEligibility(tier) }), i < arr.length - 1 && " or "] }, tier));
        });
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: eligibleTiers });
    };
    AnnualMotorTierDeclinePanelWidget.prototype.getTierWordingFromEligibility = function (tier) {
        switch (tier) {
            case "essentials":
                return services_1.resourcesHelper.PRODUCT_TIER_1;
            case "silver":
                return services_1.resourcesHelper.PRODUCT_TIER_2;
            case "allianz":
                return services_1.resourcesHelper.PRODUCT_TIER_3;
            default:
                return "";
        }
    };
    AnnualMotorTierDeclinePanelWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "process", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualMotorTierDeclinePanelWidget);
    return AnnualMotorTierDeclinePanelWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorTierDeclinePanelWidget = AnnualMotorTierDeclinePanelWidget;
//# sourceMappingURL=AnnualMotorTierDeclinePanelWidget.js.map